(() => {
  const cleanDescriptions = (root) => {
    root.querySelectorAll('.rte spangoogle, .npd__content spangoogle').forEach((element) => {
      const value = element.textContent.trim();
      const following = element.nextSibling;
      if (!value || !following || following.nodeType !== Node.TEXT_NODE) return;

      const text = following.textContent.trimStart();
      if (!text.startsWith(value)) return;
      const remainder = text.slice(value.length);
      if (remainder && !/^[\s,;.)]/.test(remainder)) return;

      element.remove();
    });
  };

  cleanDescriptions(document);
  document.addEventListener('shopify:section:load', (event) => cleanDescriptions(event.target));
})();

